import {TStateStore} from 'store';

export function getFilesNotificationManager(state: TStateStore) {
  return state.upload.notificationManager.files;
}
